import BoxesJson from '../data/modularBoxes.json';
import logo from '../images/glometal-logo.PNG';


  const getSrc = (code) => {
    try {
      return require(`../images/products/${code}.png`);
    } catch (error) {
      return logo;
    }
  }

const ModularBoxes = () => {
  return (
    <div className="products-page">
      <div className='white-cards-wrapper'>
        <h3 style={{ color: '#e47931' }}>Our Products</h3>
        <h1>Modular Boxes</h1>
        <div className='white-card-container'>
          {BoxesJson.map((product, index) => ( !product.hidden &&
            <a href={`/modular-boxes/${product.name}`} className='white-card' key={index}>
              <img src={getSrc(product.name)} alt={product.title} />
              <h3>{product.title}</h3>
              {/* <p>Code: {product.code}</p> */}
            </a>
          ))}
        </div>
      </div>
    </div>

  );
};

export default ModularBoxes;